import { render, staticRenderFns } from "./IconCoin.vue?vue&type=template&id=3c226457&"
import script from "./IconCoin.vue?vue&type=script&lang=js&"
export * from "./IconCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c226457')) {
      api.createRecord('3c226457', component.options)
    } else {
      api.reload('3c226457', component.options)
    }
    module.hot.accept("./IconCoin.vue?vue&type=template&id=3c226457&", function () {
      api.rerender('3c226457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCoin.vue"
export default component.exports